import _toConsumableArray from "/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Keeps a ref count of all hidden elements. Added to when hiding an element, and
// subtracted from when showing it again. When it reaches zero, aria-hidden is removed.
var $5e3802645cc19319$var$refCountMap = new WeakMap();
var $5e3802645cc19319$var$observerStack = [];
function $5e3802645cc19319$export$1c3ebcada18427bf(targets) {
  var root = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document.body;
  var visibleNodes = new Set(targets);
  var hiddenNodes = new Set();
  var walk = function walk(root) {
    // Keep live announcer and top layer elements (e.g. toasts) visible.
    var _iterator = _createForOfIteratorHelper(root.querySelectorAll('[data-live-announcer], [data-react-aria-top-layer]')),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var element = _step.value;
        visibleNodes.add(element);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    var acceptNode = function acceptNode(node) {
      // Skip this node and its children if it is one of the target nodes, or a live announcer.
      // Also skip children of already hidden nodes, as aria-hidden is recursive. An exception is
      // made for elements with role="row" since VoiceOver on iOS has issues hiding elements with role="row".
      // For that case we want to hide the cells inside as well (https://bugs.webkit.org/show_bug.cgi?id=222623).
      if (visibleNodes.has(node) || node.parentElement && hiddenNodes.has(node.parentElement) && node.parentElement.getAttribute('role') !== 'row') return NodeFilter.FILTER_REJECT;
      // Skip this node but continue to children if one of the targets is inside the node.
      var _iterator2 = _createForOfIteratorHelper(visibleNodes),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var target = _step2.value;
          if (node.contains(target)) return NodeFilter.FILTER_SKIP;
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      return NodeFilter.FILTER_ACCEPT;
    };
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_ELEMENT, {
      acceptNode: acceptNode
    });
    // TreeWalker does not include the root.
    var acceptRoot = acceptNode(root);
    if (acceptRoot === NodeFilter.FILTER_ACCEPT) hide(root);
    if (acceptRoot !== NodeFilter.FILTER_REJECT) {
      var node = walker.nextNode();
      while (node != null) {
        hide(node);
        node = walker.nextNode();
      }
    }
  };
  var hide = function hide(node) {
    var _refCountMap_get;
    var refCount = (_refCountMap_get = $5e3802645cc19319$var$refCountMap.get(node)) !== null && _refCountMap_get !== void 0 ? _refCountMap_get : 0;
    // If already aria-hidden, and the ref count is zero, then this element
    // was already hidden and there's nothing for us to do.
    if (node.getAttribute('aria-hidden') === 'true' && refCount === 0) return;
    if (refCount === 0) node.setAttribute('aria-hidden', 'true');
    hiddenNodes.add(node);
    $5e3802645cc19319$var$refCountMap.set(node, refCount + 1);
  };
  // If there is already a MutationObserver listening from a previous call,
  // disconnect it so the new on takes over.
  if ($5e3802645cc19319$var$observerStack.length) $5e3802645cc19319$var$observerStack[$5e3802645cc19319$var$observerStack.length - 1].disconnect();
  walk(root);
  var observer = new MutationObserver(function (changes) {
    var _iterator3 = _createForOfIteratorHelper(changes),
      _step3;
    try {
      var _loop = function _loop() {
        var change = _step3.value;
        if (change.type !== 'childList' || change.addedNodes.length === 0) return 1; // continue
        // If the parent element of the added nodes is not within one of the targets,
        // and not already inside a hidden node, hide all of the new children.
        if (![].concat(_toConsumableArray(visibleNodes), _toConsumableArray(hiddenNodes)).some(function (node) {
          return node.contains(change.target);
        })) {
          var _iterator4 = _createForOfIteratorHelper(change.removedNodes),
            _step4;
          try {
            for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
              var node = _step4.value;
              if (node instanceof Element) {
                visibleNodes.delete(node);
                hiddenNodes.delete(node);
              }
            }
          } catch (err) {
            _iterator4.e(err);
          } finally {
            _iterator4.f();
          }
          var _iterator5 = _createForOfIteratorHelper(change.addedNodes),
            _step5;
          try {
            for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
              var _node = _step5.value;
              if ((_node instanceof HTMLElement || _node instanceof SVGElement) && (_node.dataset.liveAnnouncer === 'true' || _node.dataset.reactAriaTopLayer === 'true')) visibleNodes.add(_node);else if (_node instanceof Element) walk(_node);
            }
          } catch (err) {
            _iterator5.e(err);
          } finally {
            _iterator5.f();
          }
        }
      };
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        if (_loop()) continue;
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
  });
  observer.observe(root, {
    childList: true,
    subtree: true
  });
  var observerWrapper = {
    observe: function observe() {
      observer.observe(root, {
        childList: true,
        subtree: true
      });
    },
    disconnect: function disconnect() {
      observer.disconnect();
    }
  };
  $5e3802645cc19319$var$observerStack.push(observerWrapper);
  return function () {
    observer.disconnect();
    var _iterator6 = _createForOfIteratorHelper(hiddenNodes),
      _step6;
    try {
      for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
        var node = _step6.value;
        var count = $5e3802645cc19319$var$refCountMap.get(node);
        if (count == null) continue;
        if (count === 1) {
          node.removeAttribute('aria-hidden');
          $5e3802645cc19319$var$refCountMap.delete(node);
        } else $5e3802645cc19319$var$refCountMap.set(node, count - 1);
      }
      // Remove this observer from the stack, and start the previous one.
    } catch (err) {
      _iterator6.e(err);
    } finally {
      _iterator6.f();
    }
    if (observerWrapper === $5e3802645cc19319$var$observerStack[$5e3802645cc19319$var$observerStack.length - 1]) {
      $5e3802645cc19319$var$observerStack.pop();
      if ($5e3802645cc19319$var$observerStack.length) $5e3802645cc19319$var$observerStack[$5e3802645cc19319$var$observerStack.length - 1].observe();
    } else $5e3802645cc19319$var$observerStack.splice($5e3802645cc19319$var$observerStack.indexOf(observerWrapper), 1);
  };
}
export { $5e3802645cc19319$export$1c3ebcada18427bf as ariaHideOutside };